import { ValidatorService } from './tools/validator.service';
import { AutenticacionService } from './autenticacion.service';
import { Http, ResponseContentType } from '@angular/http';
import { ConstantsService } from './constants.service';
import { Injectable } from '@angular/core';
import { ErrorsService } from './tools/errors.service';
declare var $;

@Injectable()
export class ConfiguracionCreditosService {

  private service_url;
  constructor(private constantsService: ConstantsService, private http: Http, private authService: AutenticacionService, private validatorService: ValidatorService, private errorService: ErrorsService) {
    this.service_url = this.constantsService.apiURL + '/configuracion/creditos';
  }

  getDefaultSchedule() {
    return {
      'id': '',
      'descripcion': '',
      'catalogos_plazos': [],
      'configuracion_creditos': { "value" : ""}
    };
  }

  getDefaultScheduleArray() {
    return [{
      'id': '',
      'descripcion': '',
      'catalogos_plazos': [],
      'configuracion_creditos': {}
    }];
  }

  get(page = null, limit = 10) {
    if (page) {
      return this.http.get(this.service_url + '?paginate=true&limit='+ limit +'&page=' + page , this.authService.getAuthHeaders());
    }
    return this.http.get(this.service_url, this.authService.getAuthHeaders());
  }

  // buscar objeto simple
  search(filter, search, page = null) {
    // buscar con paginacion
    if (page)
      return this.http.get(this.service_url + "?paginate=true&filter=" + filter + "&search=" + search + "&page=" + page, this.authService.getAuthHeaders());

    // solo buscar
    return this.http.get(this.service_url + "?paginate=true&filter=" + filter + "&search=" + search, this.authService.getAuthHeaders());
  }

  update(data, id) {
    return this.http.put(this.service_url + '?id=' + id, data, this.authService.getAuthHeaders());
  }

  public writePermission() {
    return true;
    //return this.authService.hasPermission(10, true);
  }

  public validatePlazos(anios, plazos){
    let error = [];

    if(!this.validatorService.required(plazos)){
      error["plazos"] = this.errorService.required;
    }

    if(!this.validatorService.required(anios)){
      error["anios"] = this.errorService.required;
    }

    return error;
  }

  public validate(data){
    console.log("validating Plazos... ", data);
    
    let error = [];
    
    if(!this.validatorService.required(data.configuracion_creditos.value)){
      error["maximo"] = this.errorService.required;
    }

    return error;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/configuracion-creditos.service.ts